import classNames from 'classnames';
import React, { ReactElement } from 'react';

import { useIsRendered } from '../../shared/hooks/useIsRendered';
import { IQATestableProps } from '../../shared/types/IQATestableProps';
import { IRenderCallback } from '../../shared/types/IRenderCallback';

import { SkeletonBoxPresenter } from './skeleton-box-presenter/SkeletonBoxPresenter';
import styles from './SkeletonBox.module.css';

export type ISkeletonLoadingBarProps = IQATestableProps;

export function OzSkeletonLoadingBar (props: ISkeletonLoadingBarProps): ReactElement {
    const {
        'data-testid': dataTestId,
    }: ISkeletonLoadingBarProps = props;

    const [isRendered, box, onBoxRender]: [boolean, HTMLDivElement | undefined, IRenderCallback<HTMLDivElement | null>]
        = useIsRendered<HTMLDivElement>();

    const presenter: SkeletonBoxPresenter = new SkeletonBoxPresenter({
        box,
    });

    const loadingBoxStyle: { [key: string]: string } = {};

    if (isRendered) {
        loadingBoxStyle.width = `${presenter.getBoxWidth()}px`;
        loadingBoxStyle.left = `${presenter.getBoxLeft()}px`;
    }

    const containerClassNames = classNames({
        'overflow-hidden absolute top-0 left-0 right-0 bottom-0': true,
        [styles.skeletonBox]: true,
    });

    return (
        <div data-testid={dataTestId} className={containerClassNames}>
            <div ref={onBoxRender} style={loadingBoxStyle} className={`absolute ${styles.loadingBox}`}/>
        </div>
    );
}
